import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 24px 32px;

  header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    
    img {
      width: 64px;
      height: 64px;
    }

    span {
      color: ${ ({ theme }) => theme.colors.primary };
      font-size: 22px;
      font-weight: 700 !important;
    }
  }
  
  
  section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
    font-size: 16px;

    .radioButtons-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 8px;
    }
  }

  footer {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
`